import { stylesheet } from 'typestyle';
import { font } from '../../assets/styles';

const styles = stylesheet({
  schedule: {
    fontWeight: font.weight.regular,
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    marginTop: 6,
  },
});

export default styles;
